<template>
  <div
      class="context-menu"
      ref="popper"
      v-show="isVisible"
      tabindex="-1"
      v-click-outside="close"
      @contextmenu.capture.prevent>
    <div class="title">
      {{ selectionText }}
    </div>

    <ul class="context-menu-list">
      <slot :contextData="contextData">
        <template v-for="action in actions">
          <li
              v-show="action.visible"
              class="context-menu-item"
              :class="actionClass(action)"
              :key="`menu-${action.title}`"
              @click="click(action)"
              tabindex="0"
          >
            <span class="icon">
                <span v-if="action.confirmable && subAction && subAction.title === action.title">
                  <svg style="fill: #ffa500 !important;" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/></svg>
                </span>
                <span v-else v-html="action.icon"></span>
            </span>

            <span v-if="action.confirmable && subAction && subAction.title === action.title">
               <span style="color:#ffa500">Bevestigen</span>
            </span>
            <span v-else-if="action.title">{{ action.title }}</span>

            <ul v-if="action.items">
              <li class="context-menu-item" :class="actionClass(item)" v-for="item in action.items" :key="item.title" @click="click(action, item)">
                <span v-html="item.icon" class="icon" v-if="item.icon"></span>
                <span v-if="item.name">{{ item.name }}</span>
                <span v-else>...</span>
              </li>
            </ul>

            <ul
                v-show="action.component"
                :class="`content-menu-subitem-${action.action}`"
                class="context-menu-component"
            >
              <li>
                <component :is="action.component" @fire="click(action, $event)" :groups="groups"></component>
              </li>
            </ul>
          </li>
        </template>
      </slot>
    </ul>
  </div>
</template>

<script>
import { createPopper } from '@popperjs/core';
import ClickOutside from 'vue-click-outside'

export default {
  props: {
    actions: {
      type: Array,
      default: null,
    },

    groups: {
      type: Array,
      default: () => {
        return [];
      }
    },

    selectionText: {
      type: String,
      default: null,
    },

    boundariesElement: {
      type: String,
      default: 'body',
    },
  },

  data() {
    return {
      opened: false,
      contextData: {},
      clickData: null,
      subAction: null,
    };
  },

  directives: {
    ClickOutside,
  },

  computed: {
    isVisible() {
      return this.opened;
    },

    selectionTitle() {
      return this.groups.map(group => group.group.name).join(', ');
    },
  },

  methods: {
    open(evt, contextData) {
      this.subAction = null;
      this.opened = true;
      this.contextData = contextData;
      document.body.classList.add("context-menu-open");

      this.$emit('open', contextData);

      if (this.popper) {
        this.popper.destroy();
      }

      const boundary = document.body;
      this.popper = createPopper(this.referenceObject(evt), this.$refs.popper, {
        placement: 'right-start',
        modifiers: [
          {
            name: 'eventListeners',
            options: { scroll: false }
          },
          {
            name: 'preventOverflow',
            options: {
              escapeWithReference: true,
            }
          },
          {
            name: 'flip',
            options: {
              padding: 5,
              boundary,
            },
          },
        ],
      });

      document.onkeydown = (evt) => {
        evt = evt || window.event;
        if (evt.keyCode == 27) {
          this.close();
        }
      };
    },

    click(action, subItem) {
      if (! subItem && (action.items || action.component || (action.confirmable && (!this.subAction || this.subAction.action !== action.action)))) {
        this.subAction = action;
        if (this.subPopper) {
          this.subPopper.destroy();
        }

        this.subPopper = createPopper(document.querySelector(`.action__${action.action}`), document.querySelector(`.content-menu-subitem-${action.action}`), {
          placement: 'right',
          modifiers: [
            {
              name: 'flip',
              options: {
                fallbackPlacements: ['left'],
                padding: 8,
              },
            },
          ],
        });

        setTimeout(() => {
          const inputElement = document.body.querySelector('.context-menu .active input');
          if (inputElement) {
            inputElement.focus();
          }
        }, 100);
      } else {
        const data = { action: action.action, event: action, subAction: subItem };
        this.clickData = data;
        this.$emit('action', data);
      }
    },

    close() {
      if (this.opened || document.body.classList.contains("context-menu-open")) {
        this.opened = false;
        this.contextData = null;
        this.subAction = null;
        document.body.classList.remove('context-menu-open', 'disable-scroll');

        this.$emit('close', this.clickData);
      }
    },

    referenceObject(evt) {
      return {
        getBoundingClientRect: () => ({
          top: evt.pageY - window.pageYOffset,
          right: evt.pageX - window.pageXOffset,
          bottom: evt.pageY,
          left: evt.pageX,
          width: 0,
          height: 0,
        }),
        clientWidth: 0,
        clientHeight: 0,
      }
    },

    actionClass(action) {
      const classes = [`action__${action.action}`];
      if (this.subAction && this.subAction.action === action.action) {
        classes.push('active');
      }

      classes.push(`action__${action.type ? action.type : 'default'}`);

      return classes.join(' ');
    },
  },

  beforeDestroy() {
    if (this.popper !== undefined) {
      this.popper.destroy();
    }

    document.onkeydown = null;
  },
};

</script>



// WEBPACK FOOTER //
// resources/js/components/AppContextMenu.vue